import React, { useEffect, useRef, useState } from "react";
import { Button, Card, CardBody, Col, Container, Form, Input, InputGroup, Label, Modal, ModalBody, ModalHeader, Row, } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Controller, useForm,  } from "react-hook-form";
import { get, post } from "helpers/api_helper";
import { NOZZLE_LIST, ORDER_CREATE,CUSTOMER_LIST } from "helpers/url_helper";
import { useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import Select from "react-select";

const CreateOrder = () => {
  const [modalOpen, setModalOpen] = useState(false); // Modal state
  const [nozzels, setNozzels] = useState([]); // Nozzels state
  const [imageData, setImageData] = useState(null);
  const [cameraReady, setCameraReady] = useState(false);
  const webcamRef = useRef(null);
  const [facingMode, setFacingMode] = useState("environment");
  const [isFetchingCustomers, setIsFetchingCustomers] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [isMultiSelect, setIsMultiSelect] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const role = Number(authUser?.user?.role);
      setIsAdmin(role === 1);
    } catch {
      setIsAdmin(false);
    }
  }, []);
   const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (!modalOpen) {
      setImageData(null);
    }
  };
  useEffect(() => {
    window.google &&
      window.google.load("elements", "1", {
        packages: "transliteration",
        callback: onLoadTransliteration,
      });

    function onLoadTransliteration() {
      const control =
        new window.google.elements.transliteration.TransliterationControl({
          sourceLanguage:
            window.google.elements.transliteration.LanguageCode.ENGLISH,
          destinationLanguage: [
            window.google.elements.transliteration.LanguageCode.GUJARATI,
          ],
          transliterationEnabled: true,
        });
      control.makeTransliteratable(["name", "address", "notes"]);
    }
  }, []);

  useEffect(() => {
    getNozzleList();
  }, []);

  const base64ToBlob = (base64, mime = "image/jpeg") => {
    const byteString = atob(base64.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mime });
  };

  async function getNozzleList() {
    try {
      const response = await get(NOZZLE_LIST);
      const items = response?.data?.items.length > 0 ? response.data.items : [];
      const options = items.map((item) => ({
        label: `${item.vehicle_no}`,
        value: item.ul_id,
      }));
      setNozzels(options);
    } catch (error) {
      console.error("Error fetching nozzle list:", error);
    }
  }

  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
    setValue,
    control,
  } = useForm({
    defaultValues: { 
      phone: "",
      vehicle_no: "",
      name: "",
      ltr: "",
      total_price: "",
      Price: 100,
      date: new Date().toISOString().slice(0, 10),
      customer_status: "",
      notes: "",
      proof: "",
      nozzel_ul_id: "",
     },
  });
  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Create Order", link: "#" },
  ];
  const [dateFlatpickr, setDateFlatpickr] = useState(null);
  const selectedCustomer = watch("customer_ul_id");
  const openCalendar = () => {
    if (dateFlatpickr) dateFlatpickr.open();
  };
const [isSwitchingCamera, setIsSwitchingCamera] = useState(false);
const switchCamera = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(device => device.kind === 'videoinput');
      
      if (videoDevices.length < 2) {
        toastr.info("Only one camera available");
        return;
      }

      // First get the current mode
      const currentMode = typeof facingMode === 'object' ? facingMode.exact : facingMode;
      const newMode = currentMode === "user" ? "environment" : "user";
      
      // For Android devices
      if (/Android/i.test(navigator.userAgent)) {
        // Test if the camera is available
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: { exact: newMode } }
          });
          stream.getTracks().forEach(track => track.stop());
          
          // Only update state if the camera is available
          setFacingMode({ exact: newMode });
        } catch (error) {
          toastr.error("Could not switch to this camera");
          return;
        }
      } else {
        // For iOS and other devices
        setFacingMode(newMode);
      }

      setCameraReady(false);
    } catch (error) {
      console.error("Camera switch error:", error);
      toastr.error("Failed to switch cameras");
    }
  };

  // Corrected videoConstraints using the facingMode state
const videoConstraints = () => {
  return {
    facingMode: facingMode,
    width: { ideal: 1280 },
    height: { ideal: 720 }
  };
};
 
useEffect(() => {
  const detectCameras = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(d => d.kind === 'videoinput');
      
      // Default to back camera if available
      if (videoDevices.length > 1) {
        // iOS devices
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          setFacingMode({ exact: "environment" });
        } 
        // Android devices
        else if (/Android/i.test(navigator.userAgent)) {
          setFacingMode("environment");
        }
      }
    } catch (error) {
      console.error("Camera detection error:", error);
    }
  };

  if (modalOpen) {
    detectCameras();
  }
}, [modalOpen]);
 
  const navigate = useNavigate();
  const onSubmit = async (value) => {

    const formData = new FormData();

    for (const [key, val] of Object.entries(value)) {
      if (key !== "proof") {
        formData.append(key, val);
      }
    }

    if (imageData) {
      const imageBlob = base64ToBlob(imageData, "image/jpeg");
      formData.append("proof", imageBlob, "proof.jpg");
    }

    // const payload = {
    //   ...value,
    //   status: value?.customer_status,
    //   proof: imageData || value.proof,
    // };
    try {
      const response = await post(ORDER_CREATE, formData);
      console.log(response);
      toastr.success("Order placed successfully!");
      reset();
      navigate("/orders"); // ✅ lowercase
    } catch (error) {
      toastr.error("Failed to place order.");
      console.error("Submit error:", error);
    }
  };
  const [inputMode, setInputMode] = useState("ltr"); // "ltr" or "price"
  const ratePerLiter = 100; // change this as needed
  const watchLtr = watch("ltr");
  const watchPrice = watch("price");

  useEffect(() => {
    if (inputMode === "ltr" && watchLtr && !isNaN(watchLtr)) {
      setValue("price", (parseFloat(watchLtr) * ratePerLiter).toFixed(2));
    } else if (inputMode === "price" && watchPrice && !isNaN(watchPrice)) {
      setValue("ltr", (parseFloat(watchPrice) / ratePerLiter).toFixed(2));
    }
  }, [watchLtr, watchPrice, inputMode]);

   const captureImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setImageData(imageSrc);
      setValue("proof", imageSrc, { shouldValidate: true });
    }
  };

    const fetchCustomers = async () => {
    try {
      setIsFetchingCustomers(true);

      // Make API call with large page size to get all customers
      const response = await get(`${CUSTOMER_LIST}?page=0&size=1000`); // Adjust size as needed

      if (!response || !response.data) {
        throw new Error("Invalid API response structure");
      }

      // Handle both possible response structures
      const customersData = response.data.items || response.data;

      if (!Array.isArray(customersData)) {
        throw new Error("Expected array of customers");
      }

      const newCustomers = customersData.map((customer) => ({
        value: customer.ul_id,
        label: `${customer.phone} : ${customer.name}`,
        ...customer,
      }));

      setCustomers(newCustomers);
      toastr.success(`Loaded ${newCustomers.length} customers`);
    } catch (error) {
      console.error("Failed to fetch customers:", error);
      toastr.error("Failed to load customer list");
      setCustomers([]);
    } finally {
      setIsFetchingCustomers(false);
    }
  };

    useEffect(() => {
      fetchCustomers();
    }, []);

 const handleCustomerSelect = (selectedCustomer) => {
    if (selectedCustomer) {
      setValue("name", selectedCustomer.name || "");
      setValue("phone", selectedCustomer.phone || "");
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Create Order" breadcrumbItems={breadcrumbItems} />
        </Container>
        <Row>
          <Col xl="12">
            <Card>
              <CardBody>
                <Form className="needs-validation" method="post" id="customerCreateForm" onSubmit={handleSubmit(onSubmit)} >
                  <Row>
                    <Col md="6" xl="4">
                    <div className="mb-3 position-relative">
                      <Label className="form-label" htmlFor="phone">
                          Select Customer 
                        </Label>
                      <Select
                  options={customers}
                  onChange={handleCustomerSelect}
                  placeholder="Search customer..."
                  isClearable
                  isSearchable
                  getOptionLabel={(option) => 
                    `${option.phone} : ${option.name}`
                  }
                  getOptionValue={(option) => option.ul_id}
                />
                <small className="text-muted">
                  Select to auto-fill details
                </small>
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="phone">
                          Phone No <span className="text-danger">*</span>
                        </Label>

                        <Controller name="phone" control={control} rules={{
                          required: "Phone number is required",
                          pattern: { value: /^[0-9]*$/, message: "Please enter only numbers", },
                          minLength: { value: 10, message: "Must be 10-digits phone number", },
                          maxLength: { value: 10, message: "Must be 10-digits phone number", },
                        }}
                          render={({ field }) => (
                            <Input {...field} id="phone" placeholder="Enter Phone no" type="tel" inputMode="numeric" pattern="[0-9]*" maxLength="10"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]|Backspace|ArrowLeft|ArrowRight|Tab|Delete/.test(
                                    e.key
                                  )
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={`form-control ${errors.phone ? "is-invalid" : ""
                                }`}
                            />
                          )}
                        />
                        {errors.phone?.message && (
                          <div className="text-danger">
                            {errors.phone.message}
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="vehicle_no">
                          Vehicle Number <span className="text-danger">*</span>
                        </Label>
                        <Controller name="vehicle_no" control={control} rules={{
                          required: "Vehicle Number is required",
                          pattern: {
                            value: /^[A-Z]{2}-\d{1,2}-[A-Z]{1,3}-\d{4}$/,
                            message: "Format must be like GJ-19-Z-1587",
                          },
                        }}
                          render={({ field }) => (
                            <Input {...field} maxLength={15}
                              onChange={(e) => {
                                let raw = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                const state = raw.slice(0, 2);
                                const district = raw.slice(2, 4); // can be 1 or 2 digits
                                let remaining = raw.slice(4);
                                let series = '';
                                let number = '';
                                const match = remaining.match(/^([A-Z]{1,3})(\d{1,4})?$/);
                                if (match) {
                                  series = match[1] || '';
                                  number = match[2] || '';
                                }
                                let formatted = [state, district, series, number]
                                  .filter(Boolean)
                                  .join('-');

                                field.onChange(formatted);
                              }}
                              className={`form-control ${errors.vehicle_no ? 'is-invalid' : ''}`}
                              placeholder="e.g. GJ-00-AA-0000"
                            />
                          )}
                        />
                        {errors.vehicle_no?.message && (
                          <div className="text-danger">
                            {errors.vehicle_no.message}
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col md="6" xl="3">
                      <div className="mb-3">
                        <Label className="form-label me-2 ">Select Input Mode</Label>
                        <InputGroup>
                        <div className="form-check form-check-inline" >
                          <Input
                            type="radio"
                            className="form-check-input"
                            name="inputMode"
                            value="ltr"
                            checked={inputMode === "ltr"}
                            onChange={() => setInputMode("ltr")}
                            id="inputModeLtr"
                          />
                          <Label className="form-check-label" htmlFor="inputModeLtr">Liter</Label>
                        </div>
                        <div className="form-check form-check-inline">
                          <Input
                            type="radio"
                            className="form-check-input"
                            name="inputMode"
                            value="price"
                            checked={inputMode === "price"}
                            onChange={() => setInputMode("price")}
                            id="inputModePrice"
                          />
                          <Label className="form-check-label" htmlFor="inputModePrice">Total Price</Label>
                        </div>
                        </InputGroup>
                      </div>
                    </Col>
                    {inputMode === "ltr" && (
                      <Col md="6" xl="3">
                        <div className="mb-3 position-relative">
                          <Label className="form-label">Ltr <span className="text-danger">*</span></Label>
                          <Controller
                            name="ltr"
                            control={control}
                            rules={{
                              required: "Liter is required",
                              pattern: {
                                value: /^[0-9.]+$/,
                                message: "Only numeric values allowed"
                              }
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                type="text"
                                inputMode="decimal"
                                placeholder="Enter Liter"
                                className={`form-control ${errors.ltr ? "is-invalid" : ""}`}
                              />
                            )}
                          />
                          {errors.ltr && <div className="text-danger">{errors.ltr.message}</div>}
                        </div>
                      </Col>
                    )}

                    {inputMode === "price" && (
                      <Col md="6" xl="3">
                        <div className="mb-3 position-relative">
                          <Label className="form-label">Total Price <span className="text-danger">*</span></Label>
                          <Controller name="total_price" control={control} rules={{
                            required: "Total Amount is required",
                            pattern: {
                              value: /^[0-9.]+$/,
                              message: "Only numeric values allowed"
                            }
                          }}
                            render={({ field }) => (
                              <Input {...field} type="text" inputMode="decimal" placeholder="Enter Total Price"
                                className={`form-control ${errors.price ? "is-invalid" : ""}`}
                              />
                            )}
                          />
                          {errors.total_price && <div className="text-danger">{errors.total_price.message}</div>}
                        </div>
                      </Col>
                    )}

                    <Col md="6" xl="3">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="validationTooltip02" > Date </Label>
                        <Controller name="date" control={control} render={({ field }) => (
                          <InputGroup>
                            <Flatpickr options={{ dateFormat: "Y-m-d", defaultDate: field.value, }}
                               value={field.value ? new Date(field.value) : new Date()}
                              onChange={(selectedDates) => {
                                if (selectedDates?.[0]) {
                                  // ✅ Correct local date format
                                  const formatted = selectedDates[0].toLocaleDateString("en-CA"); // "YYYY-MM-DD"
                                  field.onChange(formatted);
                                }
                              }}
                              className="form-control"
                              placeholder="Select Date"
                            />
                            <div
                              className="input-group-append"
                              onClick={openCalendar}
                              style={{ cursor: "pointer" }}
                            >
                              <span className="input-group-text">
                                <i className="mdi mdi-calendar"></i>
                              </span>
                            </div>
                          </InputGroup>
                        )}
                        />
                      </div>
                    </Col>
                    <Col md="6" xl="3">
                      <div className="mb-3 position-relative">
                        <Label className="form-label">Name <span className="text-danger">*</span></Label>
                        <Controller
                          name="name"
                          control={control}
                          rules={{ required: "Name is required" }} // ✅ Validation rule here
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${errors.name ? "is-invalid" : ""}`} // ✅ Match error key to "name"
                              id="name"
                              placeholder="Enter name"
                            />
                          )}
                        />
                        {errors.name && (
                          <div className="invalid-feedback d-block">{errors.name.message}</div> // ✅ Show error message
                        )}
                      </div>
                    </Col>
                    <Col xl="4" md="6">
                      <div className="mb-3">
                        <Label> Select Nozzle <span className="text-danger">*</span> </Label>
                        <Controller name="nozzel_ul_id" control={control} rules={{ required: "Nozzel is required" }} render={({ field }) => (
                          <Input type="select" {...field} value={field.value || ""} onChange={(e) => field.onChange(e.target.value)}>
                            <option value="">Select Nozzle</option>
                            {nozzels.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Input>
                        )}
                        />
                        {errors.nozzel_ul_id && (
                          <div className="text-danger">
                            {errors.nozzel_ul_id.message}
                          </div>
                        )}
                      </div>
                    </Col>
                    {!isAdmin && (
                      <Col md="12" xl="4">
                      <div className="mb-3">
                        <Label>Proof</Label>
                        <Controller
                        name="proof"
                        control={control}
                        rules={{ required: "Proof photo is required" }}
                        render={({ field }) => (
                          <input
                          type="hidden"
                          value={imageData || ""}
                          {...field}
                          />
                          )}
                          />
                        {imageData ? (
                          <div>
                            <img
                              src={imageData}
                              alt="Captured proof"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "150px",
                                marginBottom: "10px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                              }}
                            />
                            <div className="d-flex gap-2">
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => setImageData(null)}
                              >
                                Retake Photo
                              </Button>
                              <Button
                                color="secondary"
                                size="sm"
                                onClick={toggleModal}
                              >
                                View Full Size
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <Button
                              color="primary"
                              size="sm"
                              className="mt-2"
                              onClick={toggleModal}
                            >
                              <i className="bx bx-camera me-1"></i> Capture Photo
                            </Button>
                            {errors.proof && (
                              <div className="text-danger mt-2">{errors.proof.message}</div>
                              )}
                          </div>
                        )}
                      </div>
                    </Col>
                    )}
                    <Col md="12" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="notes"> Remarks </Label>
                        <Controller name="notes" control={control} render={({ field }) => (
                          <Input {...field} type="textarea" style={{ height: "80px" }} className={`form-control9 `} id="notes" placeholder="Enter Remarks" />
                        )}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="text-end">
                    <Button type="submit" color="primary" disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Capture Photo Proof</ModalHeader>
        <ModalBody>
          <div className="text-center">
            {!imageData ? (
                <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints()}
                style={{
                  width: "680px",
                  maxWidth: "100%",
                  maxHeight: "100%",
                  marginBottom: "15px",
                }}
                onUserMedia={() => setCameraReady(true)}
                onUserMediaError={(error) => {
                  console.error("Camera error:", error);
                  toastr.error(`Camera error: ${error.message}`);
                  setCameraReady(false);
                  
                  // Handle specific permission errors
                  if (error.name === 'NotAllowedError') {
                    toastr.info("Please allow camera permissions in your browser settings");
                  }
                }}
              />
            ) : (
              <img
                src={imageData}
                alt="Captured proof"
                style={{
                  width: "100%",
                  maxHeight: "60vh",
                  marginBottom: "15px",
                }}
              />
            )}
          </div>

          <div className="d-flex justify-content-between">
            {!imageData ? (
              <>
              <Button
                color="primary"
                onClick={captureImage}
                disabled={!cameraReady}
              >
                <i className="bx bx-camera me-1"></i> Capture Photo
              </Button>
              <Button
              color="info"
              onClick={switchCamera}
              disabled={!cameraReady || isSwitchingCamera}
            >
              <i className="bx bx-reflect-vertical me-1"></i>
              {typeof facingMode === 'object'
                ? facingMode.exact === 'user' ? 'Back Camera' : 'Front Camera'
                : facingMode === 'user' ? 'Back Camera' : 'Front Camera'}
            </Button>
              </>
            ) : (
              <Button color="primary" onClick={() => setImageData(null)}>
                <i className="bx bx-reset me-1"></i> Retake Photo
              </Button>
            )}

            <Button
              color="success"
              onClick={() => {
                toggleModal();
              }}
              disabled={!imageData}
            >
              <i className="bx bx-check me-1"></i> Use This Photo
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
export default CreateOrder;
